import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence the benign "ResizeObserver loop completed" warning that triggers
// the CRA dev error overlay (caused by Radix UI in some popovers).
const RESIZE_OBSERVER_ERRORS = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications",
];
window.addEventListener("error", (e) => {
  if (e?.message && RESIZE_OBSERVER_ERRORS.some((m) => e.message.includes(m))) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
